<template>
	<div id="StoresComponent" class="stores-component">
		<button ref="btnGetStoreRackSideRowColumnIdsSelected" @click="getStoreRackSideRowColumnIdsSelectedLocal" v-show="false">Enviar Ids Seleccionadas</button>
		<nav aria-label="breadcrumb">
			<ol class="breadcrumb">
				<li class="breadcrumb-item active pointer" aria-current="page" @click="getAllStoresLocal" ref="btnGetStores">Bodega</li>
				<li class="breadcrumb-item pointer" aria-current="page" v-if="storeIdSelected > 0" @click="selectStoreLocal(storeIdSelected)">{{storeName}}</li>
				<li class="breadcrumb-item pointer" aria-current="page" v-if="storeRackIdSelected > 0" @click="selectStoreRackLocal(storeRackIdSelected)">{{storeRackName}}</li>
			</ol>
		</nav>
		<div v-if="breadcrumbSelect == 'listStores'">
			<div v-if="searchingStore">
				Buscando bodegas
			</div>
			<div v-else>
				<div class="row">
					<div class="col-sm-6 col-md-1 text-center m-2 pointer" v-for="(item, index) in listStores" :key="index" @click="selectStoreLocal(item.id)">
						<div class="img text-center">
							<img src="/img/store.png">
						</div>
						<div>
							{{item.name}}
						</div>
					</div>
					<div class="col-sm-6 col-md-2 text-center m-2 pointer" style="opacity: 0.5" v-if="newStore">
						<div class="img">
							<img src="/img/store.png">
						</div>
						<input type="text" class="text-center" style="width: 100%; background: transparent" placeholder="Nombre Sucursal" v-model="objectStore.name" ref="objectStoreName" @keyup="saveStoreLocal" @blur="newStore = false"/>
					</div>
					<div class="col-sm-6 col-md-1 text-center m-2 pointer" v-if="!newStore && enableActiveNewStore">
						<div class="text-center">
							<div class="plus" style="font-size: 36px;">
								+
							</div>
							<div>
								<h6>Agregar</h6>
							</div>
						</div>
					</div>
				</div>			
			</div>
		</div>
		<div class="store text-muted" v-if="breadcrumbSelect =='listStoreRacks'">
			<div v-if="searchingStoreRack">
				Buscando Racks
			</div>
			<div v-else>
				<div class="list-racks">
					<div class="rack card mx-1 pointer" v-for="(item, index) in listStoreRacks" :key="index" @click="selectStoreRackLocal(item.id)">
						<div class="card-body text-center">
							<div class="img">
								<img src="/img/rack.png">
							</div>
							<div>
								<h6>{{item.name}}</h6>
							</div>
						</div>
					</div>

					<div class="rack card mx-1 pointer" v-if="newStoreRack">
						<div class="card-body text-center">
							<div class="img">
								<img src="/img/rack.png">
							</div>
							<div>
								<input type="text" class="text-center" style="width: 100%; background: transparent" placeholder="Nombre del Rack" v-model="objectStoreRack.name" ref="objectStoreRackName" @keyup="saveStoreRackLocal" @blur="newStoreRack = false"/>
							</div>
						</div>
					</div>
					<div class="rack-plus card mx-1 pointer" v-if="!newStoreRack && enableActiveNewStoreRack" @click="activeNewStoreRack">
						<div class="card-body text-center">
							<div class="plus">
								+
							</div>
							<div>
								<h6>Agregar</h6>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="list-sides my-2" v-if="breadcrumbSelect =='listStoreRackSides'">
			<ul class="nav nav-tabs" id="myTab" role="tablist">
				<li class="nav-item side-tab" role="presentation" v-for="(item, index) in listStoreRackSides" :key="index" @click="selectStoreRackSideLocal(item.id)">
					<button class="nav-link" :class="(storeRackSideIdSelected == item.id) ? 'active' : ''" :id="'side-tab-' + item.id" data-toggle="tab" :data-target="'#side-' + item.id" type="button" role="tab" :aria-controls="'side-' + item.id" aria-selected="true" :ref="'nav-link-' + item.id">
						{{ item.name }} <i class="fas fa-grip-lines-vertical" :style="'color:' + item.color"></i>
					</button>
				</li>
				<li class="nav-item" role="presentation" v-if="enableActiveNewStoreRackSide">
					<div class="nav-link pointer" :class="(storeRackSideIdSelected == 0) ? 'active' : ''" id="new-store-rack-side-tab" data-toggle="tab" data-target="#newStoreRackSide" role="tab" aria-controls="newStoreRackSide" aria-selected="false" @click="setNewStoreRackSideLocal">+</div>
				</li>
			</ul>
			<div class="tab-content side-content" id="myTabContent">
				<div class="tab-pane fade" v-for="(item, index) in listStoreRackSides" :key="index" :class="(storeRackSideIdSelected == item.id) ? 'show active' : ''" :id="'home-' + item.id" role="tabpanel" :aria-labelledby="'home-tab-' + item.id">
					<div class="my-3 text-center table-responsive">
						<side-component
							:ref="'sideComponent-' + item.id"
							:id="storeRackSideIdSelected"
							:multipleSelection="multipleSelection"
							:enableActiveNewStoreRackSideModule="enableActiveNewStoreRackSideModule"
							@actionShowStoreRackSideRowColumn = "actionShowStoreRackSideRowColumnLocal"
							@actionGetStoreRackSideRowColumnIdsSelected = "actionGetStoreRackSideRowColumnIdsSelectedLocal">
						</side-component>
					</div>
				</div>
				<div class="tab-pane fade" :class="(storeRackSideIdSelected == 0) ? 'show active' : ''" id="newStoreRackSide" role="tabpanel" aria-labelledby="new-store-rack-side-tab">
					<div class="row justify-content-md-center my-3">
						<div class="col-md-auto">
							<div>
								<div class="form-group">
									<label for="exampleInputEmail1">Nombre</label>
									<input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Escriba un nombre para este lado"  v-model="objectStoreRackSide.name">
								</div>
								<div class="form-group">
									<label for="exampleInputPassword1">Color</label>
									<input type="color" class="form-control" id="exampleInputPassword1" v-model="objectStoreRackSide.color">
								</div>
								<button class="btn btn-primary" @click="saveStoreRackSideLocal">Guardar</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Button trigger modal -->
		<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#example1Modal" ref="btnShowColumnComponentModal" v-show="false">
			Show Column Modal
		</button>

		<!-- Modal -->
		<div class="modal fade" id="example1Modal" tabindex="-1" aria-labelledby="example1ModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="modal-body">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
							<column-component
								ref="columnComponent"
								:id="storeRackSideRowColumnIdSelected">
							</column-component>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import stores from '@/mixins/stores'
	import storeRack from '@/mixins/stores/storeRack.js'
	import storeRackSide from '@/mixins/stores/storeRackSide.js'

	import SideComponent from '@/components/SideComponent.vue'
	import ColumnComponent from '@/components/ColumnComponent.vue'
	
	export default {
		name: 'StoresComponent',
		mixins: [axiosAction, errors, mixin, stores, storeRack, storeRackSide],
		props: ['multipleSelection', 'enableActiveNewStore', 'enableActiveNewStoreRack', 'enableActiveNewStoreRackSide', 'enableActiveNewStoreRackSideModule'],
		data () {
			return {
				breadcrumbSelect: 'Stores',
				newStore: false,
				newStoreRack: false,
				storeRackSideRowColumnIdSelected: 0
			}
		},
		components: {
			'side-component': SideComponent,
			'column-component': ColumnComponent,
		},
		computed: {
			storeName() {
				let index = this.listStores.map((el) => (el.id)).indexOf(parseInt(this.storeIdSelected))
				return (index > -1) ? this.listStores[index].name : 'Sin definir'
			},
			storeRackName() {
				let index = this.listStoreRacks.map((el) => (el.id)).indexOf(parseInt(this.storeRackIdSelected))
				return (index > -1) ? this.listStoreRacks[index].name : 'Sin definir'
			}
		},
		methods: {
			activeNewStore() {
				this.clearObjectStore()
				this.newStore = true
				setTimeout(() => {this.$refs.objectStoreName.focus()}, 100)
			},
			activeNewStoreRack() {
				this.clearObjectStoreRack()
				this.newStoreRack = true
				setTimeout(() => {this.$refs.objectStoreRackName.focus()}, 100)
			},
			actionGetStoreRackSideRowColumnIdsSelectedLocal(ids) {
				this.$emit('actionGetStoreRackSideRowColumnIdsSelected', ids)
			},
			actionShowStoreRackSideRowColumnLocal(id) {
				this.storeRackSideRowColumnIdSelected = id
				this.$refs.btnShowColumnComponentModal.click()
				setTimeout(() => {this.$refs.columnComponent.$refs.btnShowStoreRackSideRowColumn.click()}, 100)
			},
			initComponent() {
				console.log('Buscar Bodegas...')
			},
			getAllStoresLocal() {
				this.newStore = false
				this.breadcrumbSelect = 'listStores'
				this.storeIdSelected = 0
				this.storeRackIdSelected = 0
				this.getAllStores()
			},
			getAllStoresResultLocal(response) {
			},
			getStoreRacksByStoreIdLocal(storeId) {
				this.newStoreRack = false
				this.getStoreRacksByStoreId(storeId)
			},
			getStoreRacksByStoreIdResultLocal(response) {},
			getStoreRackSidesByStoreRackIdLocal(storeRackId) {
				this.getStoreRackSidesByStoreRackId(storeRackId)
			},
			getStoreRackSidesByStoreRackIdResultLocal(response) {
				if(response.data.success == true) {
					if(this.listStoreRackSides.length > 0) {
						this.selectStoreRackSideLocal(this.listStoreRackSides[0].id)
					}
				}
			},
			getStoreRackSideRowColumnIdsSelectedLocal() {
				if(this.storeRackSideIdSelected > 0) {
					this.$refs['sideComponent-' + this.storeRackSideIdSelected][0].$refs.btnGetStoreRackSideRowColumnSelected.click()
				} else {
					this.$emit('actionGetStoreRackSideRowColumnIdsSelected', false)
				}
			},
			resultAxiosLocal(responseLocal, response) {
				switch(responseLocal) {
					case 'getAllStoresResult': this.getAllStoresResult(response); break;				
					case 'getStoreRacksByStoreIdResult': this.getStoreRacksByStoreIdResult(response); break;				
					case 'getStoreRackSidesByStoreRackIdResult': this.getStoreRackSidesByStoreRackIdResult(response); break;				
					case 'saveStoreResult': this.saveStoreResult(response); break;				
					case 'saveStoreRackResult': this.saveStoreRackResult(response); break;				
					case 'saveStoreRackSideResult': this.saveStoreRackSideResult(response); break;				
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
				this.$emit('hideLockScreen')
			},
			saveStoreLocal(e) {
				if(e.keyCode == 13) {
					if(this.objectStore.name.trim().length > 1) {
						this.saveStore(this.objectStore)
					} else {
						this.$snotify.error('Tiene que tener como minimo 2 caracteres', 'No realizado')
					}
				}
			},
			saveStoreResultLocal(response) {
				if(response.data.success == true) {
					this.listStores.push(response.data.data)
					this.newStore = false
					this.selectStoreLocal(response.data.data.id)
				}
			},
			saveStoreRackLocal(e) {
				if(e.keyCode == 13) {
					if(this.objectStoreRack.name.trim().length > 0) {
						this.objectStoreRack.store_id = this.storeIdSelected
						this.saveStoreRack(this.objectStoreRack)
					} else {
						this.$snotify.error('Tiene escribir algo para guardarlo', 'No realizado')
					}
				}
			},
			saveStoreRackResultLocal(response) {
				if(response.data.success == true) {
					this.listStoreRacks.push(response.data.data)
					this.newStoreRack = false
					this.selectStoreRackLocal(response.data.data.id)
				}
			},
			saveStoreRackSideLocal() {
				this.saveStoreRackSide(this.objectStoreRackSide)
			},
			saveStoreRackSideResultLocal(response) {
				if(response.data.success == true) {
					this.selectStoreRackSideLocal(response.data.data.id)
				}
			},
			selectStoreLocal(storeId) {
				this.breadcrumbSelect = 'listStoreRacks'
				this.storeIdSelected = storeId
				this.storeRackIdSelected = 0
				this.getStoreRacksByStoreIdLocal(this.storeIdSelected)
			},
			selectStoreRackLocal(storeRackId) {
				this.breadcrumbSelect = 'listStoreRackSides'
				this.storeRackIdSelected = storeRackId
				this.setNewStoreRackSideLocal()
				this.getStoreRackSidesByStoreRackIdLocal(this.storeRackIdSelected)
			},
			selectStoreRackSideLocal(storeRackSideId) {
				this.storeRackSideIdSelected = storeRackSideId
				setTimeout(() => { this.$refs['sideComponent-' + this.storeRackSideIdSelected][0].$refs.btnGetStoreRackSide.click() }, 10)
			},
			setNewStoreRackSideLocal() {
				this.storeRackSideIdSelected = 0
				this.clearObjectStoreRackSide()
				this.objectStoreRackSide.name = ''
				this.objectStoreRackSide.store_id = this.storeIdSelected
				this.objectStoreRackSide.store_rack_id = this.storeRackIdSelected
			}
		},
		mounted () {
			this.initComponent()
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
	.stores-component {
		.img {
			img {
				width: 100%;
			}
		}
		.store {
			.list-racks {
				scroll-snap-type: x mandatory;
				display: flex;
				width: 100%;
				overflow-x: auto;
				.rack {
					scroll-snap-align: center;
					flex: 0 0 130px;
					width: 130px;
					object-fit: cover;
					opacity: 0.7;
					.img {
						height: 100px;
						img {
							opacity: 0.8;
							max-width: 100%;
							max-height: 100px;
						}
					}
				}
				.rack:hover {
					opacity: 1;
				}
				.rack-plus {
					scroll-snap-align: center;
					flex: 0 0 110px;
					width: 110px;
					object-fit: cover;
					opacity: 0.7;
					.plus {
						line-height: 75px;
  						height: 75px;
  						font-size: 36px;
					}
				}
				.rack-plus:hover {
					opacity: 1;
				}
			}
		}
		.store-plus {
			scroll-snap-align: center;
			flex: 0 0 110px;
			width: 110px;
			object-fit: cover;
			opacity: 0.7;
			.plus {
				line-height: 65px;
				height: 65px;
				font-size: 36px;
			}
		}
		.store-plus:hover {
			opacity: 1;
		}	
	}
	::-webkit-scrollbar {
		width: 2px;
		height: 4px;
	}

	/* Track */
	::-webkit-scrollbar-track {
		background: #fff;
	}

	/* Handle */
	::-webkit-scrollbar-thumb {
		opacity: 0.5;
		background: #00b7bd;
	}

	/* Handle on hover */
	::-webkit-scrollbar-thumb:hover {
		opacity: 1;
	}
</style>
